import React from "react";
import "./GallerySection.css";


import luxuryg1 from "../../assets/luxuryg1.png";
import luxuryg2 from "../../assets/luxuryg2.png";
import luxuryg3 from "../../assets/luxuryg3.png";
import luxuryg4 from "../../assets/luxuryg4.png";
import luxuryg5 from "../../assets/luxuryg5.png"
const cars = [

  {
    img: luxuryg1,
    className: "medium",
  },
  {
    img: luxuryg2,
    className: "medium",
  },
  {
    img: luxuryg3,
    className: "small",
  },
  {
    img: luxuryg4,
    className: "medium",
  },
  {
    img: luxuryg5,
    className: "small",
  },
];

const GallerySection = () => {
  return (
    <div className="car-gallery-container">
      <h1 className="gallery-title">Our Fleet Your Journey</h1>

      <div className="gallery-grid">
        {cars.map((car, index) => (
          <div key={index} className={`gallery-item ${car.className}`}>
            <img src={car.img} alt="car" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GallerySection;
